import { createStateSelectorHook } from 'src/lib/sweetState';
import { SystemStore } from 'src/store';

const useSystemState = createStateSelectorHook(SystemStore, ['applicationMode']);

export const useApplicationMode = () => {
  const { applicationMode } = useSystemState();
  return applicationMode;
};
